/* global kakao */
import React, { useEffect } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

import { Card, CardHeader, Button } from "@/Components/Common/Tailwind";
import cn from "classnames";
import { KakaoMapModal } from "../../Components/modal/ManagerModal";

const MapSection = styled.div`
  flex: 1;
  width: 100%;
  height: 200px;
  /* height:600px; */
`;

const KakaoMap = ({
  coordinate,
  siteName,
  siteLogo,
  address,
  permission,
  interactive = false, // interactive prop to control map interaction
  compact = false,
}) => {
  const navigate = useNavigate();

  const [mapAddress, setMapAddress] = React.useState("");
  const [kakaoMapEditModal, setKakaoMapEditModal] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState("");

  useEffect(() => {
    if (address) {
      setMapAddress(address);
    }
  }, [address]);

  // const [coordinate, setCoordinate] = React.useState({
  //   "lat": 0,
  //   "lng": 0
  // });
  // const [siteName, setSiteName] = React.useState("");
  // const [siteLogo, setSiteLogo] = React.useState("");

  // useEffect(() => {
  //   API.get(`/sites/coordinate/${SITE_ID}/`)
  //     .then((response) => response.data)
  //     .then((data) => {
  //       if (data && Object.keys(data).length > 0) {
  //         // console.log("map data: ", data);
  //         if (!data.map_marker || !data.address || !data.name) {
  //           console.warn("데이터가 잘못되었습니다.", data);
  //         }

  //         setCoordinate(data.map_marker);
  //         setMapAddress(data.address);
  //         setSiteName(data.name);
  //         setSiteLogo(data.logo);
  //       }
  //     })
  //     .catch((error) => {
  //       setErrorMsg("사이트 데이터 로드 실패");
  //       console.log("error on /sites/coordinate", error);
  //     });
  // }, []);

  useEffect(() => {
    if (!coordinate || !mapAddress || !coordinate?.lat || !coordinate?.lng) {
      return;
    }

    if (typeof window === "undefined") {
      return;
    }

    let cancelled = false;

    const waitForKakaoMaps = () => new Promise((resolve, reject) => {
      const startTime = Date.now();
      const timer = setInterval(() => {
        if (cancelled) {
          clearInterval(timer);
          return;
        }

        const maps = window?.kakao?.maps;
        if (maps?.LatLng && maps?.Map && maps?.Marker) {
          clearInterval(timer);
          resolve(maps);
          return;
        }

        if (maps?.load) {
          maps.load(() => {
            if (cancelled) return;
            if (maps?.LatLng && maps?.Map && maps?.Marker) {
              resolve(maps);
            } else {
              reject(new Error("Kakao Maps SDK not ready"));
            }
          });
          clearInterval(timer);
          return;
        }

        if (Date.now() - startTime > 10000) {
          clearInterval(timer);
          reject(new Error("Kakao Maps SDK not ready"));
        }
      }, 100);
    });

    try {
      waitForKakaoMaps()
        .then((maps) => {
          if (cancelled) return;
          const container = document.getElementById("map");
          if (!container) return;

          const options = {
            center: new maps.LatLng(Number(coordinate.lat), Number(coordinate.lng)),
            level: 4,
          };

          const map = new maps.Map(container, options);
          const marker = new maps.Marker({
            position: options.center,
          });

          marker.setMap(map);

          const iwContent = `
          <div style="padding:20px 15px;">
            <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center; gap: 12px; height: 32px; margin-bottom: 4px;">
              <img src="${siteLogo}" style="width:32px; height:32px; border-radius: 50%; display:${siteLogo ? "block" : "none"}"/>
              <span style="text-align:center;">${siteName}</span>
            </div>
            <p style="font-size: 16px; color: #222;">${mapAddress}</p>
          </div>
        `;

          const infoWindow = new maps.InfoWindow({
            content: iwContent,
          });

          infoWindow.open(map, marker);
        })
        .catch((error) => {
          if (cancelled) return;
          console.error("Kakao Maps initialization error:", error);
          setErrorMsg("Kakao Maps SDK 로드에 실패했습니다.");
        });
    } catch (error) {
      console.error('Kakao Maps initialization error:', error);
    }

    return () => {
      cancelled = true;
    };
  }, [coordinate, mapAddress, siteName, siteLogo]);

  if (!coordinate || !mapAddress || !coordinate?.lat || !coordinate?.lng) {
    return (
      <Card className={cn("Map")} style={{ width: "100%", maxWidth: "100%" }}>
        <CardHeader>
          {!!permission && permission.permission > 0 ? (
            <Button
              className="btn-soft-primary position-absolute top-0 end-0"
              onClick={() => setKakaoMapEditModal(!kakaoMapEditModal)}
              style={{ fontFamily: "Gmarket-M", backgroundColor: "#f6475f1a", boxShadow: "none", border: "none", fontSize: "13px", color: "#f6475f", marginRight: "10px" }}
            >
              지도 위치 수정
            </Button>
          ) : null}
        </CardHeader>
        <KakaoMapModal visible={kakaoMapEditModal} setVisible={setKakaoMapEditModal} setAddress={setMapAddress} navigate={navigate} />
      </Card>
    )
  }

  if (errorMsg) {
    return (
      <Card className={cn("Map")} style={{ width: "100%", maxWidth: "100%" }}>
        <CardHeader>
          {!!permission && permission.permission > 0 ? (
            <Button
              className="btn-soft-primary position-absolute top-0 end-0"
              onClick={() => setKakaoMapEditModal(!kakaoMapEditModal)}
              style={{ fontFamily: "Gmarket-M", backgroundColor: "#f6475f1a", boxShadow: "none", border: "none", fontSize: "13px", color: "#f6475f", marginRight: "10px" }}
            >
              지도 위치 수정
            </Button>
          ) : null}
        </CardHeader>
        <div style={{ textAlign: "center", padding: "20px" }}>
          <p>{errorMsg}</p>
        </div>
        <KakaoMapModal visible={kakaoMapEditModal} setVisible={setKakaoMapEditModal} setAddress={setMapAddress} navigate={navigate} />
      </Card>
    )
  }

  return (
    <Card className={cn("Map")} style={{ width: "100%", maxWidth: "100%" }}>
      <CardHeader>
        {!!permission && permission.permission > 0 ? (
          <Button
            className="btn-soft-primary position-absolute top-0 end-0"
            onClick={() => setKakaoMapEditModal(!kakaoMapEditModal)}
            style={{ fontFamily: "Gmarket-M", backgroundColor: "#f6475f1a", boxShadow: "none", border: "none", fontSize: "13px", color: "#f6475f", marginRight: "10px" }}
          >
            지도 위치 수정
          </Button>
        ) : null}
      </CardHeader>

      {Object.keys(coordinate).length !== 0 ? (
        <MapSection
          className={cn("MapContainer card-title mb-0 w-full  flex flex-md-column flex-fill")}
          id="map"
          style={{ height: compact ? "160px" : "200px" }}
        />
      ) : (
        <div></div>
      )}

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
          alignItems: "center",
          padding: compact ? "12px" : "20px",
          gap: compact ? "8px" : "0",
        }}
      >
        <Button
          asChild
          variant="outline"
          className="text-[#444] border-[#d1d5db] no-underline hover:no-underline"
          style={{
            fontSize: compact ? "13px" : "16px",
            fontWeight: "bold",
          }}
        >
          <a
            href={`https://map.kakao.com/link/map/${siteName},${coordinate.lat},${coordinate.lng}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            카카오맵에서 보기
          </a>
        </Button>
        <Button
          asChild
          variant="outline"
          className="text-[#444] border-[#d1d5db] no-underline hover:no-underline"
          style={{
            fontSize: compact ? "13px" : "16px",
            fontWeight: "bold",
          }}
        >
          <a
            href={`https://map.naver.com/v5/search/${siteName}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            네이버맵에서 보기
          </a>
        </Button>
      </div>

      <KakaoMapModal visible={kakaoMapEditModal} setVisible={setKakaoMapEditModal} setAddress={setMapAddress} navigate={navigate} />
    </Card>
  );
};

export default KakaoMap;
